import React, { useState } from "react"
import { OldButton } from "@kit/design/old-button"
import Input from "@kit/design/input"
import { useToggle } from "hooks/use-toggle"
import { Link } from "./link"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { useEditing } from "app/regions/hooks/use-editing"
import { appFont } from "app/regions/blocks/setting-utils"
import { getLinkMeta } from "app/forms/utils/get-link-meta"
import { Block } from "../shared/block"
import { getIconFromUrl } from "./get-icon-from-url"

export function Links({ id }) {
  const { properties, children, add } = useBlocks(id)

  const { fontSize, fontWeight, ...linkStyles } = properties

  return (
    <Block
      id={id}
      style={{ fontSize: fontSize + "px", fontWeight }}
      data-block-id={id}
      className="ck-links-block"
    >
      {children.map(link => (
        <Link key={link.block_id} styles={linkStyles} {...link} />
      ))}
      <AddLink add={add} styles={linkStyles} />
    </Block>
  )
}

function AddLink({ add, styles }) {
  const editing = useEditing()
  const [open, toggle] = useToggle()
  const [loading, setLoading] = useState(false)
  const [url, setUrl] = useState("")

  async function handleAdd() {
    if (!url.trim()) return
    setLoading(true)
    try {
      const result = getIconFromUrl(url)
      const meta = await getLinkMeta(url)
      add({
        type: "link",
        properties: {
          icon: result.icon,
          text: meta.title,
          url: result.url
        }
      })
    } catch (e) {
      add({
        type: "link",
        properties: {
          icon: "external-link",
          text: "Click to edit this link text",
          url: url
        }
      })
    }
    toggle()
    setLoading(false)
    setUrl("")
  }

  const buttonStyles = {
    padding: "1em",
    margin: "1em 0",
    fontFamily: appFont,
    borderRadius: styles.borderRadius
  }

  if (!editing) return false

  if (open) {
    return (
      <div
        className="p-4 border rounded shadow"
        style={{ fontFamily: appFont }}
      >
        <Input
          value={url}
          onChange={e => setUrl(e.target.value)}
          style={{ fontFamily: appFont }}
          placeholder="Link URL (https://example.com)"
          className="mb-2"
          type="text"
          tabIndex="0"
          // eslint-disable-next-line
          autoFocus
        />
        <OldButton
          is="secondary"
          onClick={toggle}
          className="mr-2"
          style={{ fontFamily: appFont }}
        >
          Cancel
        </OldButton>
        <OldButton
          is="primary"
          onClick={handleAdd}
          style={{ fontFamily: appFont }}
          disabled={loading}
        >
          {loading ? "Adding..." : "Add link"}
        </OldButton>
      </div>
    )
  }

  return (
    <OldButton
      onClick={toggle}
      className="flex items-center justify-center w-full border-dashed border-2 text-gray-800 hover:text-gray-900 hover:border-gray-500 transition-colors duration-200 focus:border-gray-800 focus:text-gray-900 focus:outline-none"
      style={buttonStyles}
      icon="plus-circle"
    >
      Add link
    </OldButton>
  )
}
